import type { DemoSummary, ResultResponse } from "./types";

const STATIC_MODE = import.meta.env.VITE_STATIC_DATA !== "false";
const LIVE_BASE =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  "http://localhost:8000";

const LIVE_API = `${LIVE_BASE.replace(/\/+$/, "")}/api/v1`;
const STATIC_BASE = `${import.meta.env.BASE_URL.replace(/\/+$/, "")}/data`;

class ApiError extends Error {
  constructor(public status: number, public url: string, msg: string) {
    super(msg);
  }
}

async function jfetch<T>(url: string): Promise<T> {
  const res = await fetch(url, { headers: { Accept: "application/json" } });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = (await res.json()) as { detail?: string };
      if (body?.detail) detail = body.detail;
    } catch {
      /* non-JSON error body, keep statusText */
    }
    throw new ApiError(res.status, url, detail);
  }
  return (await res.json()) as T;
}

export function listDemos(): Promise<DemoSummary[]> {
  const url = STATIC_MODE ? `${STATIC_BASE}/demos.json` : `${LIVE_API}/demos`;
  return jfetch<DemoSummary[]>(url);
}

export function getResult(eventLogId: string): Promise<ResultResponse> {
  const url = STATIC_MODE
    ? `${STATIC_BASE}/logs/${eventLogId}.json`
    : `${LIVE_API}/logs/${eventLogId}/result`;
  return jfetch<ResultResponse>(url);
}

export { ApiError };
